module.exports = __webpack_public_path__ + "img/EDC8000_1-1.d7f5b405.jpg";